var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7106 17.8242C9.28604 17.8242 5.50757 18.4925 5.50757 21.169C5.50757 23.8454 9.26207 24.5377 13.7106 24.5377C18.1351 24.5377 21.9125 23.8683 21.9125 21.1929C21.9125 18.5176 18.1591 17.8242 13.7106 17.8242Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7107 14.0067C16.6143 14.0067 18.9677 11.6546 18.9677 8.75396C18.9677 5.85328 16.6143 3.50226 13.7107 3.50226C10.8071 3.50226 8.45267 5.85328 8.45267 8.75396C8.44286 11.6448 10.781 13.997 13.6737 14.0067H13.7107Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTabIcon);
export default __webpack_public_path__ + "static/media/ProfileTabIcon.f556f514dde0d6549f0b66dd7e27aba7.svg";
export { ForwardRef as ReactComponent };